export var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["Any"] = 0] = "Any";
    AccessLevel[AccessLevel["Guest"] = 10] = "Guest";
    AccessLevel[AccessLevel["Standard"] = 20] = "Standard";
    AccessLevel[AccessLevel["Admin"] = 30] = "Admin";
    AccessLevel[AccessLevel["Installator"] = 40] = "Installator";
    AccessLevel[AccessLevel["Support"] = 50] = "Support";
})(AccessLevel || (AccessLevel = {}));
export var Gender;
(function (Gender) {
    Gender[Gender["Unknown"] = 0] = "Unknown";
    Gender[Gender["Men"] = 1] = "Men";
    Gender[Gender["Woman"] = 2] = "Woman";
    Gender[Gender["Other"] = 3] = "Other";
})(Gender || (Gender = {}));
export var Localization;
(function (Localization) {
    Localization[Localization["En_Us"] = 0] = "En_Us";
    Localization[Localization["Pl_Pl"] = 1] = "Pl_Pl";
})(Localization || (Localization = {}));
//# sourceMappingURL=IUser.js.map